<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Licence History Of {{ subscriptionDisplayId }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Licence History</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="row">
    <div class="col-xl-9">
      <div class="row">
        <!--<div class="col-xl-12">-->
        <div class="card border-0">
          <div class="card-header"></div>
          <div class="card-body p-0 mt-1">
            <div class="custom-datatable-filter">
              <div class="row">
                <p class="col-lg-4 text-lg-end">Plan:</p>
                <p class="col-lg-2 fw-bold">{{ (subscription$ | async).planName }}</p>
                <p class="col-lg-2 text-lg-end">Price:</p>
                <p class="col-lg-4 fw-bold">
                  {{
                    (subscription$ | async).priceAfterDiscount
                      | currency: (subscription$ | async).planCurrencySymbol : 'symbol' : '1.2-2'
                  }}
                  / User
                </p>
              </div>
              <div class="row">
                <p class="col-lg-4 text-lg-end">Billing Frequency:</p>
                <p class="col-lg-2 fw-bold">{{ (subscription$ | async).planType | capitalize }}</p>
                <p class="col-lg-2 text-lg-end">Total Licences:</p>
                <p class="col-lg-4 fw-bold">
                  {{ (subscription$ | async).licences?.[0]?.totalLicences }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-4 text-lg-end">Recurring Charges:</p>
                <p class="col-lg-2 fw-bold">
                  {{
                    (subscription$ | async).licences?.[0]?.amount
                      | currency: (subscription$ | async).planCurrencySymbol : 'symbol' : '1.2-2'
                  }}
                </p>
                <p class="col-lg-2 text-lg-end">Used Licences:</p>
                <p class="col-lg-4 fw-bold">
                  {{ (subscription$ | async).licences?.[0]?.usedLicences }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-4 text-lg-end">Next Billing Date:</p>
                <p class="col-lg-2 fw-bold">
                  {{ (subscription$ | async).licences?.[0]?.nextBillingDate | date: 'mediumDate' }}
                </p>
                <p class="col-lg-2 text-lg-end">Remaining Licences:</p>
                <p class="col-lg-4 fw-bold">
                  {{
                    (subscription$ | async).licences?.[0]?.totalLicences -
                      (subscription$ | async).licences?.[0]?.usedLicences
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-4 text-lg-end">Customer Since:</p>
                <p class="col-lg-2 fw-bold">
                  {{ (subscription$ | async).createdAt | date: 'mediumDate' }}
                </p>
                <p class="col-lg-2 text-lg-end">Subscription Status:</p>
                <p class="col-lg-4 fw-bold">
                  {{ (subscription$ | async).subscriptionStatus | capitalize }}
                  <span class="ps-1">
                    <a href="javascript:void(0);" (click)="openModal(changeStatusModal)"
                      ><i class="ti ti-edit"></i>
                    </a>
                  </span>
                </p>
              </div>
              <div class="row">
                <p class="col-lg-4 text-lg-end">Trial Days:</p>
                <p class="col-lg-2 fw-bold">
                  {{ (subscription$ | async).trialDays }}
                  <span class="ps-1">
                    <a href="javascript:void(0);" (click)="openModal(changeTrialDaysModal)"
                      ><i class="ti ti-edit"></i>
                    </a>
                  </span>
                </p>
                <p class="col-lg-2 text-lg-end"></p>
                <p class="col-lg-4 fw-bold"></p>
              </div>
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
      <div class="row">
        <div class="card border-0 p-0">
          <div class="card-body p-0 mt-0">
            <div class="custom-datatable-filter table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Purchased On</th>
                    <th>Total Licences</th>
                    <th>Used Licences</th>
                    <th>Charge</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let licence of (subscription$ | async)?.licences">
                    <td>
                      {{ licence.createdAt | date: 'mediumDate' }}
                    </td>
                    <td>{{ licence.totalLicences }}</td>
                    <td>{{ licence.usedLicences }}</td>
                    <td>
                      {{
                        licence.chargeAmount
                          | currency
                            : (subscription$ | async).planCurrencySymbol
                            : 'symbol'
                            : '1.2-2'
                      }}
                    </td>
                    <td>
                      {{
                        licence.amount
                          | currency
                            : (subscription$ | async).planCurrencySymbol
                            : 'symbol'
                            : '1.2-2'
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 theiaStickySidebar">
      <div class="card">
        <div class="card-body">
          <!-- <div class="d-flex flex-column list-group settings-list"> -->
          <div class="d-grid">
            <button
              (click)="openModal(addLicenceModal)"
              class="btn btn-primary mb-3"
              type="button"
              *ngIf="(subscription$ | async).subscriptionStatus === 'Active'"
            >
              Add Licence
            </button>
            <button class="btn btn-primary" type="button">Upgrade Plan</button>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Licences -->
<ng-template #addLicenceModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Licence</h4>
    <button
      (click)="closeModal()"
      type="button"
      class="btn-close custom-btn-close"
      aria-label="Close"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <p class="mb-3">
            Total Licences:
            <span class="fw-bold">{{ (subscription$ | async).licences?.[0]?.totalLicences }}</span>
          </p>
          <p class="mb-3">
            Used Licences:
            <span class="fw-bold">{{ (subscription$ | async).licences?.[0]?.usedLicences }}</span>
          </p>
          <p class="mb-3">
            Remaining Licences:
            <span class="fw-bold">{{
              (subscription$ | async).licences?.[0]?.totalLicences -
                (subscription$ | async).licences?.[0]?.usedLicences
            }}</span>
          </p>
          <p class="mb-3">
            Updated Licences:
            <span class="fw-bold">{{ totalLicences + form.value.addedLicences }}</span>
          </p>
          <div class="mb-3">
            <label for="name" class="form-label"
              >Add Licence<span class="text-danger"> *</span></label
            >
            <input
              appTrimInput
              type="number"
              id="name"
              class="form-control"
              formControlName="addedLicences"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        (click)="addLicence()"
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid"
      >
        Save
      </button>
    </div>
  </form>
</ng-template>
<!-- /Add Licences -->

<!-- Change Status -->
<ng-template #changeStatusModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Change Status</h4>
    <button
      (click)="closeModal()"
      type="button"
      class="btn-close custom-btn-close"
      aria-label="Close"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label for="belongsTo" class="form-label">Status</label>
          <select class="form-select" [formControl]="subscriptionStatusForm">
            <option value="" disabled>Select Status</option>
            <option *ngFor="let item of subscriptionStatusValues" [value]="item">
              {{ item | capitalize }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      (click)="updateStatus()"
      [disabled]="subscriptionStatusForm.invalid"
      class="btn btn-primary"
    >
      Save
    </button>
  </div>
</ng-template>
<!-- /Change Status -->

<!-- Change Trial Days -->
<ng-template #changeTrialDaysModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Change Trial Days</h4>
    <button
      (click)="closeModal()"
      type="button"
      class="btn-close custom-btn-close"
      aria-label="Close"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label for="belongsTo" class="form-label">Enter Trial Days</label>
          <input
            appTrimInput
            type="number"
            class="form-control"
            [formControl]="trialDaysForm"
            min="0"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="updateTrialDays()" [disabled]="trialDaysForm.invalid" class="btn btn-primary">
      Save
    </button>
  </div>
</ng-template>
<!-- /Change Trial Days -->
